export default __webpack_public_path__ + "static/media/hazelcast.40933e41.svg";